'use client';

import { useEffect, useState } from 'react';

/**
 * Hook to detect if the component has mounted on the client.
 * Useful for avoiding hydration mismatches when rendering client-only content.
 *
 * @example
 * ```tsx
 * function MyComponent() {
 *   const hasMounted = useHasMounted();
 *
 *   // This will only render after hydration, avoiding mismatches
 *   if (!hasMounted) {
 *     return <div>0</div>; // Server/initial render
 *   }
 *
 *   return <div>{clientOnlyValue}</div>;
 * }
 * ```
 */
export function useHasMounted(): boolean {
  const [hasMounted, setHasMounted] = useState(false);

  useEffect(() => {
    setHasMounted(true);
  }, []);

  return hasMounted;
}
